import { Component, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon } from '../../icon/icon';

@Component({
  selector: 'li[app-progress-data-block-item]',
  imports: [DataItemTemplate, Icon],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      <app-icon [size]="iconSize()" class="icon" icon="check" />
      <p class="name">%</p>
      <p class="value">{{ percent() }}</p>
      <div class="gauge">
        <div class="gauge-fill" [style.height.%]="percent()"></div>
      </div>
    </app-data-item-template>
  `,
  styleUrl: './progress-data-block-item.scss',
})
export class ProgressDataBlockItem extends DataItemTemplate {
  readonly percent: Signal<number> = this.webSocketService.completionPercent;
}
